import React from 'react';
import AdminButton from './AdminButton'; // Importar AdminButton

const Header = ({ isAdmin, onAdminAccess, onLogoutAdmin, showCustomizer = true }) => {
  const scrollTo = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <header className="bg-green-600 text-white shadow-lg sticky top-0 z-50">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        <div className="flex items-center space-x-2">
          <span className="text-2xl">🍹</span>
          <h1 className="text-xl font-bold">Jugos Doña Wicha</h1>
        </div>
        <nav className="hidden md:flex items-center space-x-6">
          {!isAdmin && (
            <>
              <button 
                onClick={() => scrollTo('menu')}
                className="px-3 py-1 rounded hover:bg-green-700 transition-colors"
              >
                Menú
              </button>
              {showCustomizer && (
                <button 
                  onClick={() => scrollTo('personaliza')} 
                  className="px-3 py-1 rounded hover:bg-green-700 transition-colors"
                >
                  Personaliza
                </button>
              )}
              <button 
                onClick={() => scrollTo('pedidos')}
                className="px-3 py-1 rounded hover:bg-green-700 transition-colors"
              >
                Pedidos
              </button>
            </>
          )}
          
          {/* Botón Admin integrado en el navbar */}
          {!isAdmin && <AdminButton onAdminAccess={onAdminAccess} />}
          {isAdmin && (
            <button
              onClick={onLogoutAdmin}
              className="px-4 py-2 bg-gray-800 text-white rounded-lg hover:bg-gray-700 transition-colors"
            >
              Salir Admin
            </button>
          )}
        </nav>
        <button className="md:hidden text-xl">☰</button>
      </div>
    </header>
  );
};

export default Header;